<template>
  <v-card>
    <v-card-title class="body-1">
      {{
        currentFleetId > 0
          ? $vuetify.lang.t('$vuetify.EDIT_FLEETS.EDIT_FLEET')
          : $vuetify.lang.t('$vuetify.EDIT_FLEETS.ADD_NEW_FLEET')
      }}
      <v-spacer></v-spacer>
      <v-btn icon small @click="closeForm()">
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text
      class="d-flex align-center justify-center"
      style="min-height: 868px;"
    >
      <fleet-form
        @valid="saveButtonDisabled = false"
        @invalid="saveButtonDisabled = true"
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        style="position: fixed; right: 36px; bottom: 36px;"
        color="primary"
        class="secondary--text"
        :disabled="saveButtonDisabled"
        @click="saveFleet()"
      >
        {{ $vuetify.lang.t('$vuetify.SAVE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import Fleet from '@/models/fleet'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'EditFleetDialog',
  components: {
    FleetForm: () =>
      import(
        /* webpackChunkName: "FleetForm" */ '@/components/fleets/FleetForm'
      )
  },
  props: {
    id: String
  },
  data() {
    return {
      saveButtonDisabled: true
    }
  },
  computed: {
    ...mapGetters('app', ['error']),
    ...mapGetters('fleets', ['currentFleetId', 'fleets'])
  },
  created() {
    if (this.id > 0 && !this.currentFleetId) {
      if (this.id !== this.currentFleetId) {
        this.setCurrentFleetId(this.id)
      }
    }
  },
  methods: {
    ...mapMutations('fleets', ['setCurrentFleetId']),
    ...mapActions('fleets', ['getFleet', 'getFleetUsers', 'getFleets']),
    async saveFleet() {
      try {
        await this.$store.dispatch(
          'fleets/postFleet',
          this.$store.state.fleets.fleet
        )
        this.$store.commit('fleets/setCurrentFleetId', 0)
        this.$router.replace('/fleets')
        this.$store.commit('fleets/setFleet', new Fleet().getObject())
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error in saveFleet:', error)
      }
    },
    closeForm() {
      this.$router.replace('/fleets')
      this.$store.commit('fleets/setCurrentFleetId', 0)
      this.$store.commit('fleets/setFleet', new Fleet().getObject())
    }
  }
}
</script>
